import { render } from "./PersonalInfoTab.vue?vue&type=template&id=4148aefd"
import script from "./PersonalInfoTab.vue?vue&type=script&lang=js"
export * from "./PersonalInfoTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__